import { Heading } from '@chakra-ui/react'

export const HelpHeader = () => {
  return <Heading>Help</Heading>
}
